import { $Q } from "./querySelector"
let lastTrigger = null

export const initCartAccessibility = () => {
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const cart = $Q('#shopify-section-side-cart')

      if (cart && cart.dataset.active === 'true') {
        cart.dataset.active = 'false'

        overlayActions?.({
          isActive: true,
          target: cart
        })
        if (lastTrigger) {
          lastTrigger.focus()
        }
      }
    }
  })
}

/**
 * Open nodes with CSS and dataset
 * @param {String} node selector who detect click
 * @param {String} query selector with the node to open
 * @param {Object} config Obejct with attribute from config open
 *
 * @return {Function}
 */

export const toggleDataActive = (node, parent, config) => {
  const { overlay, focusEl } = config ? config : { overlay: false }
  const toOpen = parent ? $Q(parent) : $Q(node)

  const handler = (e) => {
    if (e.type === 'click') {
      lastTrigger = e.currentTarget
      dataToggle(toOpen, overlay)
    }

    if (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault()
      lastTrigger = e.currentTarget
      dataToggle(toOpen, overlay)
    }
  }

  const element = $Q(node)

  element.addEventListener('click', handler)
  element.addEventListener('keydown', handler)
}

export function dataToggle(nodeToOpen, overlay, focusEl) {
  const dataset = nodeToOpen.dataset.active
  const isActive = dataset != 'true' ? false : true

  if (!dataset) return null
  if (!isActive) {
    nodeToOpen.dataset.active = 'true'

    setTimeout(() => {
      const focusable =
        nodeToOpen.querySelector('[autofocus]') ||
        nodeToOpen.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')

      if (focusable) {
        focusable.focus()
      } else {
        nodeToOpen.setAttribute('tabindex', '-1')
        nodeToOpen.focus()
      }
    }, 0)

  } else {
    nodeToOpen.dataset.active = 'false'
  }

  overlay && overlayActions({
    isActive,
    target: nodeToOpen
  })
}

const overlayActions = ({ isActive, target }) => {
  const id = target.getAttribute('id')

  if (!isActive) {
    const before = document.createElement('div')
    before.setAttribute('id', `overlay--${id}`)
    before.classList.add('overlay')
    target.parentNode.insertBefore(before, target)
    toggleDataActive(
      `#overlay--${id}`,
      `#${id}`,
      { overlay: true }
    )
  } else {
    target.parentNode.removeChild($Q(`#overlay--${id}`))
  }
}